var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100"},[_c('Filters',{attrs:{"list":_vm.filtersList},on:{"metaJoin":_vm.updatefilters}}),_c('ManageProductList',{attrs:{"products":_vm.products,"fetching":_vm.fetching,"error":_vm.error,"endList":_vm.endList,"page":_vm.page,"nodata":_vm.nodata,"pageSize":_vm.pageSize},on:{"scrollEnd":_vm.getProducts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }